import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import HorarioIcon from "../../assets/icons/horario.png";
import HorariosFechamentosService from "../../services/HorariosFechamentosService";
import HorariosService from "../../services/HorariosService";

export default function HorariosFechamentosForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idHorarioFechamento: null,
    tipo: "",
    diaSemana: "",
    data: "",
    idHorario: "",
    descricao: "",
    ativo: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [horarios, setHorarios] = useState([]);
  const hoje = new Date().toISOString().split("T")[0];

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {

    if (modo === "novo") {
      setForm({
        idHorarioFechamento: null,
        tipo: "",
        diaSemana: "",
        data: "",
        idHorario: "",
        descricao: "",
        ativo: false,
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idHorarioFechamento: itemSelecionado.IDHORARIOFECHAMENTO,
        tipo: itemSelecionado.TIPO,
        diaSemana: itemSelecionado.DIA_SEMANA ?? "",
        data: itemSelecionado.DATA ?? "",
        idHorario: itemSelecionado.ID_HORARIO ?? "",
        horario:itemSelecionado.HORARIO ?? "",
        descricao: itemSelecionado.DESCRICAO ?? "",
        ativo: itemSelecionado.ATIVO,
      });
    }
  }, [modo, itemSelecionado]);


   
async function carregarHorarios(data) {
    if (!data) {
      setHorarios([]);
      return;
    }

    const response = await HorariosService.getDisponiveis(data);

    if (Array.isArray(response)) {
      setHorarios(response);
    } else if (Array.isArray(response?.data)) {
      setHorarios(response.data);
    } else {
      setHorarios([]);
    }
  }

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;

    if (name === "tipo") {
      setForm(prev => ({
        ...prev,
        tipo: value,
        diaSemana: "",
        data: "",
        idHorario: ""
      }));
      setHorarios([]);
      return;
    }

    if (name === "ativo") {
      setForm(prev => ({ ...prev, ativo: value === "true" }));
      return;
    }

    if (name === "data" && form.tipo === "H") {
      carregarHorarios(value);
      setForm(prev => ({ ...prev, idHorario: "" }));
    }

    setForm(prev => ({ ...prev, [name]: value }));
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.tipo) e.tipo = "Informe o tipo de fechamento";

    if (form.tipo === "F" && form.diaSemana === "")
      e.diaSemana = "Informe o dia da semana";

    if (form.tipo === "D" && !form.data)
      e.data = "Informe a data";

    if (form.tipo === "H") {
      if (!form.data) e.data = "Informe a data";
      if (!form.idHorario) e.idHorario = "Informe o horário";
    }

    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);

    try {
      if (modo === "novo") {

        const payload_create = {
          TIPO: form.tipo,
          DIA_SEMANA: form.diaSemana || null,
          DATA: form.data || null,
          ID_HORARIO: form.idHorario ? Number(form.idHorario) : null,
          DESCRICAO: form.descricao,
          ATIVO: Boolean(form.ativo),
        };

        await HorariosFechamentosService.create(payload_create);
        setRetorno({
          tipo: "sucesso",
          mensagem: "Fechamento criado com sucesso!",
        });
      }

      if (modo === "alterar") {

        const payload_update = {
          IDHORARIOFECHAMENTO: form.idHorarioFechamento,
          TIPO: form.tipo,
          DIA_SEMANA: form.diaSemana || null,
          DATA: form.data || null,
          ID_H: form.idHorario ? Number(form.idHorario) : null,
          DESCRICAO: form.descricao,
          ATIVO: Boolean(form.ativo),
        };

        await HorariosFechamentosService.update(
          form.idHorarioFechamento,
          payload_update
        );
        setRetorno({
          tipo: "sucesso",
          mensagem: "Fechamento atualizado com sucesso!",
        });
      }

      onClose();
    } catch {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar fechamento."
            : "Erro ao atualizar fechamento.",
      });
      onClose();
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={HorarioIcon} alt="" className="icon" />
          {modo === "novo"
            ? "Cadastro de Fechamento"
            : "Alterar Fechamento"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Tipo *</div>
          <select name="tipo" value={form.tipo} onChange={handleChange}>
            <option value="">Selecione</option>
            <option value="F">Folga</option>
            <option value="D">Dia</option>
            <option value="H">Horário</option>
          </select>
          {errors.tipo && <span className="erro">{errors.tipo}</span>}
        </div>

        {form.tipo === "F" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Dia da Semana *</div>
            {/*<input name="diaSemana" value={form.diaSemana} onChange={handleChange} /> */}
            <select name="diaSemana" value={form.diaSemana} onChange={handleChange} >
              <option value="">Selecione um dia</option>
              <option value="7">Domingo</option>
              <option value="1">Segunda-Feira</option>
              <option value="2">Terça-Feira</option>
              <option value="3">Quarta-Feira</option>
              <option value="4">Quinta-Feira</option>
              <option value="5">Sexta-Feira</option>
              <option value="6">Sábado</option>
             </select>
            {errors.diaSemana && <span className="erro">{errors.diaSemana}</span>}
          </div>
        )}

        {(form.tipo === "D" || form.tipo === "H") && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Data *</div>
            <input type="date" min={hoje} name="data" value={form.data} onChange={handleChange} />
            {errors.data && <span className="erro">{errors.data}</span>}
          </div>
        )}

        {form.tipo === "H" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Horário *</div>
              <select name="idHorario" value={form.idHorario} onChange={handleChange}>

                {modo === "novo" && (
                  <option value="">Selecione</option>
                )}
                
                {modo === "alterar" && (
                  <option value="">
                      {itemSelecionado ? `Horário Fechado: ${itemSelecionado.horario?.slice(0,5)}h` : "Selecione um horário"}
                  </option>
                )}

                {Array.isArray(horarios) && horarios.map(h => (
                  <option key={h.idHorario} value={h.idHorario}>
                    {h.horario.slice(0, 5)} h
                  </option>
                ))}
              </select>
            {errors.idHorario && <span className="erro">{errors.idHorario}</span>}
          </div>
        )}

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição</div>
          <input name="descricao" value={form.descricao} onChange={handleChange} />
        </div>

        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Ativo</div>
            <select name="ativo" value={String(form.ativo)} onChange={handleChange}>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        )}

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Enviando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
